import { Model } from '@vuex-orm/core'
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'
import Quiz from './quiz'

/**
 * Une reponse proposee par un quizz (REDMINE-12962).
 *
 * Creee APRES le quizz : la creation d'un quizz complet n'est donc pas
 * atomique. La base garantit qu'un quizz ne porte jamais deux bonnes reponses
 * (index unique partiel), c'est au formulaire de garantir qu'il en porte au
 * moins une avant publication.
 */
export default class QuizAnswer extends Model {
  static entity = 'quiz_answers'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      'label': this.attr({}),
      'correct': this.boolean(false),
      // Ordre des rangees numerotees ① ② ③ de la maquette.
      'position': this.number(null).nullable(),
      'quiz': this.belongsTo(Quiz, 'quiz_id'), 'quiz_id': this.attr(null),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = ['quiz_id']

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
